
import appService from 'AppService.js';
import commonService from 'CommonService.js';
import Moment from 'moment';
import userService from 'UserService';
import constants from 'Constants';
import util from 'util/Util';
import listService from 'ListService.js';

class WorkspaceTableCommon {

    constructor() {        
    }

    reloadTable(data, context){

        $('#apps-table').bootstrapTable('load', data);
        if(!data || data.length === 0){
            this.showScreen(0,context);
        }
    }

    bindIconsEvents(){
        const appsTable = $('#apps-table');

        window.appOptionsEv = {
            'click .design': function (e, value, row, index) {
                if(value.permissions){
                    value.design(row.id)
                }
            },
            'click .publish': function (e, value, row, index) {
                if(value.permissions){
                    const version = row.version.split(".")[1];
                    const canPublish = userService.checkPermissions('publish') && value.permissions["@deploy"] === "allow";
                    if (canPublish && version !== "0") {
                        value.publish(row.id)
                    }
                }
            },
            'click .view': function (e, value, row, index) {
                    value.view(row.id);
            },
            'click .link': function (e, value, row, index) {
                if(value.permissions && row.status !== "Draft"){
                    value.link(row.id);
                }
            },
            'click .favorite': function (e, value, row, index) {

                const values = value;
               
                if(value.favorite.val){
                    values.favorite.val = false;
                    commonService.unsetFavorite(row.id, value.favorite.objType).then((result)=>{
                        appsTable.bootstrapTable('updateRow', {
                            index: index,
                            row: {
                                appFunctions: values
                            }
                        });

                    });
                }
                else{
                    values.favorite.val = true;
                    commonService.setFavorite(row.id, value.favorite.objType).then((result)=>{
                        appsTable.bootstrapTable('updateRow', {
                            index: index,
                            row: {
                                appFunctions: values
                            }
                        });
                    });
                }
            },
            'click .more': function (e, value, row, index) {

                const tableContextMenu = $(value.contextMenu)
                //Event to hide context menu
                $(document).on("mouseup", (e) => {
                    if (!tableContextMenu.is(e.target) // if the target of the click isn't the container
                        && tableContextMenu.has(e.target).length === 0) // nor a descendant of the container
                    {
                        tableContextMenu.hide();
                    }
                });

                let isAdmin = false;
                let canPublish = false;
                let isBasic = true;
                let isDraft = row.status == "Draft";
               
                if(value.permissions){
                    isAdmin = value.permissions["@administer"] === "allow";
                    canPublish = userService.checkPermissions('publish') && value.permissions["@deploy"] === "allow";
                    isBasic = false;
                }

                if(!isAdmin){
                    $(".admin-fx").attr("title", constants.NOT_ADMIN);
                    $(".admin-fx").addClass("disabled");
                } 
                else{
                    $(".admin-fx").attr("title","");
                    $(".admin-fx").removeClass("disabled");
                }     
                
                const design = tableContextMenu.find(".design-app");
                const link = tableContextMenu.find(".link-app");
                const details = tableContextMenu.find(".details-app");

                if(isBasic){
                    design.attr("title", constants.NOT_ADMIN);
                    design.addClass("disabled");

                    link.attr("title", constants.NOT_ADMIN);
                    link.addClass("disabled");
                }
                else{
                    design.removeClass("disabled");
                    link.removeClass("disabled");

                    if(row.status === "Draft"){
                        link.attr("title", constants.DISABLED_LINK);
                        link.addClass("disabled");
                    }
                }

                const publish = tableContextMenu.find(".publish-app");
                    
                if (!canPublish) {
                    publish.attr("title", constants.NOT_PUBLISH);
                    publish.addClass("disabled");
                }else{

                    const version = row.version.split(".")[1];

                    if(version === "0"){
                        publish.attr("title", constants.APP_PUBLISHED);
                        publish.addClass("disabled");
                    }
                    else{
                        publish.attr("title", "");
                        publish.removeClass("disabled");
                    }
                }

                const viewReport = tableContextMenu.find(".view-app");
                if(isDraft){
                    viewReport.addClass("disabled");
                    viewReport.attr("title", constants.DRAFT_REPORT);
                }
                else{
                    viewReport.removeClass("disabled");
                }

                if(row.isPrivate){
                    tableContextMenu.find(".share-app").html("Share");
                }else{
                    tableContextMenu.find(".share-app").html("Unshare");
                }

                tableContextMenu.data({"id": row.id, "basic": isBasic, "linkId": value.linkId});
                tableContextMenu.css({top: e.clientY, left: e.clientX-150}).show();
            }
        }

        window.instancesLink = {            
            'click .instances': function (e, value, row, index) {
                if(row.appFunctions.permissions){
                    appService.appInstancesList(row.id, row.appName.name);
                }
            }
        }
    }

    bindSearchFilterEvents($table){

        let enterEvent = $.Event("keyup")
        enterEvent.code = 13;

        $(".clear-search").on("click", () => {
            $(".search-app").val("");
            $(".search-app").trigger(enterEvent);
        });

        $(".search-app").on('keyup', (e) => {

            const val = e.currentTarget.value;
            const $target = $(e.currentTarget);

            if(val.length > 0){
                $target.data().filter = val;
                $(".clear-search").show();                
            }
            else{
                $target.data().filter = "-clear";
                $(".clear-search").hide();
            }
            
            if (e.key === 'Enter' || e.code === 13) {
                filterTable();
            }
        });

        const filterTable = () => {

            const name = $("#name-search").data().filter;
            const status = $("#status-filter").data().filter;
            const date = $("#date-filter").data().filter;
            let filterName = true;
            let filterStatus = true;
            let filterDate = true;

            $table.bootstrapTable('filterBy',      
            {
                name: name,
                status: status,
                updateDate: date
            },         
                {
                    'filterAlgorithm': (row, filters) => {

                        if(filters.name !== "-clear"){
                            let expr = new RegExp(`${filters.name}.*`, "i");
                            filterName = expr.test(row.name);
                        }

                        if(filters.status !== "-clear"){
                            filterStatus = row.status.toLowerCase() === filters.status.toLowerCase();
                        }

                        if(filters.updateDate !== "-clear"){
                            const vals = filters.updateDate.split("-");
                            const today = Moment(Date.now());
                            const rowDate = Moment(row.appName.lastUpdate);
                            const newDate = today.subtract(vals[0], [vals[1]]);

                            filterDate = rowDate.isSameOrAfter(newDate);
                        }
                       
                        return filterName && filterStatus && filterDate;
                    }
                });
        }

        const filterToggle = (e, $filterContext, $input) =>{

            const target = $(e.currentTarget);
          
            if(target.hasClass("set")){
                target.removeClass("set");
                $input.val($input.data().default);
                $input.data().filter = "-clear";
            }
            else{
                $filterContext.find(".filter-button").removeClass("set");
                target.toggleClass("set");
                $input.data().filter = target.data().filterval;
                $input.val(target.text());
            }

            filterTable();            

            $filterContext.hide();
            $(".filter-button").off();
        }

        const openContextMenu = ($filterContext, $input) => {
            $(document).off().on("mouseup", (e) => {
                if (!$filterContext.is(e.target) // if the target of the click isn't the container
                    && $filterContext.has(e.target).length === 0) // nor a descendant of the container
                {
                    $filterContext.hide();
                }
            });

            $filterContext.slideDown(150);
            $(".filter-button").off().on("click", (e) => { filterToggle(e, $filterContext, $input); });
        }

        $(".date-filter").on("click", () => { openContextMenu($("#date-context-menu"), $("#date-filter")); }); 
        $(".status-filter").on("click", () => { openContextMenu($("#status-context-menu"), $("#status-filter")); });
    }

    appNameFormatter(value, row, index){
       
        return ['<div class="row app-name">', value.name, '</div>',
                '<div class="row app-lastUpdate">Last Updated: ', value.lastUpdate, '</div>'].join('');
        
    }

    iconFormatter(value, row, index) {

        const favorite = !value.favorite.val ? '<i class="pf-icon-star favorite" title="Favorite"></i>' : '<i class="pf-icon-star-fill favorite" title="Favorite"></i>';

        let canPublish = "disabled";
        let canEdit = "disabled";
        let enableLink = "disabled";
        let canView = "";
               
        if(value.permissions){
            canPublish = userService.checkPermissions('publish') && value.permissions["@deploy"] === "allow" ? "" : "disabled";
            canEdit = "";

            if(row.status !== "Draft"){
                enableLink = "";
            }

            if(canPublish === ""){
                const version = row.version.split(".")[1];

                if(version === "0"){
                    canPublish = "disabled";
                }
            }
        }

        const publishTitle = canPublish === "" ? "Publish" : constants.NOT_PUBLISH;

        let viewTitle = "New Instance";

        if(listService._activeDashboardTab === "reports"){
            viewTitle = "View Report"
            
            if(row.status === "Draft"){
                canView = "disabled"
            }
        }

        return [
            '<i class="pf-icon-edit design '+ canEdit +'" title="Design"></i>',
            '<i class="pf-icon-publish publish ' + canPublish + '" title="' + publishTitle +'"></i>',
            '<i class="pf-icon-view view '+ canView +'" title="' + viewTitle + '"></i>',
            '<i class="pf-icon-link link '+ enableLink +'" title="Get Link"></i>',
            favorite,
            '<i class="pf-icon-hor-ellipsis more" title="More Options"></i>',
        ].join('');
    }

    getDataValue(target, value){
        const tableContextMenu = $(target).closest("div");
        const val = tableContextMenu.data()[value];
        tableContextMenu.hide();
        return val;
    }
    
    showScreen(count, context){
        const hasNewPermission = util.isTrue(userService.checkPermissions(context));
        const isBULicense = util.isTrue(listService.accountSettings.IsBULicense);
        const reportEnabled = context === "Report" && isBULicense ? util.isTrue(userService.checkFeatures(context)) : true;
        
        if (reportEnabled) {
            if (count > 0) {
                $(".workspace .blank").hide();
                $(".workspace .table").show();
            }
            else {
                $(".workspace .blank").show();

                if (!hasNewPermission) {
                    $(".workspace .no-permissions").show();
                    $(".workspace .no-apps").hide();
                } else {
                    $(".workspace .no-permissions").hide();
                    $(".workspace .no-apps").show();
                }

                $(".workspace .table").hide();
            }
        }
        else {
            $(".workspace .blank").show();

            $(".workspace .feature-disabled").show();
            $(".workspace .table").hide();
        }
    }

    buildTableContextMenu(options, $el){

        const self = this;

        const $menu = $('<ul class="table-dropdown-menu" aria-labelledby="dropdownMenuicon">');
        $el.append($menu);
        
        let $option;

        _.each(options, (option)=>{

            if (option) {
                $option = $('<li class="dropdown-item ' + option.fxClass + '" style="' + option.style + '">' + option.name + '</li>');
                $menu.append($option);

                const classId = "." + option.fxClass.split(" ")[0];

                $(classId).on("click", (ev) => {

                    const current = $(ev.currentTarget);
                    const isBasic = self.getDataValue(ev.currentTarget, "basic");
                    const linkId = self.getDataValue(ev.currentTarget, "linkId");

                    if(!current.hasClass("disabled")){
                        const id = self.getDataValue(ev.currentTarget, "id");

                        if(current.hasClass("details-app") && !current.hasClass("report-details")){
                            
                            if(isBasic){
                                option.fx[1](id, isBasic, linkId);
                            }
                            else{
                                option.fx[0](id, isBasic, linkId);
                            }
                        }
                        else{
                            option.fx(id, isBasic, linkId);
                        }
                    }
                });
            }
            else{
                $option = $('<hr/>');
                $menu.append($option);
            }
        });
    }
}

const workspaceCommon = new WorkspaceTableCommon();
export default workspaceCommon;